var React = require('react');

function IconX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X"),React.createElement("g",{"fillRule":"nonzero","fill":"none","key":1},[React.createElement("rect",{"fill":"#002B41","width":"29","height":"29","rx":"3","key":0}),React.createElement("path",{"d":"M16.3,13l7.4-8.6h-1.7l-6.4,7.4-5.1-7.4h-5.9l7.7,11.2-7.7,9h1.8l6.7-7.8,5.4,7.8h5.8l-8-11.6ZM14,15.7l-.8-1.1L7,5.7h2.7l5,7.2.8,1.1,6.5,9.3h-2.7l-5.3-7.6Z","fill":"#FFF","key":1})])]);
}

IconX.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = IconX;

IconX.default = IconX;
